<template>
  <app-dialog color="blue">
    <template v-slot:dialogTitle>
      <lightning-icn
        class="blue-icon ml-5 mr-2"
        width="20px"
        height="20px"
      ></lightning-icn>
      <span class="text-blue text-lg font-bold">政務活動&nbsp;</span>
      <span class="text-blue text-lg">{{ dialogTitle }}</span>
    </template>

    <template v-slot:dialogContent>
      <div id="activities-dialog">
        <TabGroup :defaultIndex="activityDialog.tabIndex">
          <TabList class="flex space-x-1 fixed" style="right: 54px; top: 10px;">
            <Tab
              v-slot="{ selected }"
              v-bind:disabled="
                !canOpenTab(
                  currentPoliticalAction.application.option.viewType,
                  currentPoliticalAction.application.option.viewType,
                  currentPoliticalAction.application.option.isMine,
                  'request',
                )
              "
            >
              <app-document-status-button
                :class="[
                  'border-4 border-blue text-blue w-40 h-10 tab-button px-1',
                  selected ? 'tab-active' : 'border-blue border-dotted',
                ]"
                @click="
                  changeDocumentTitle(
                    'request',
                    canOpenTab(
                      currentPoliticalAction.application.option.viewType,
                      currentPoliticalAction.application.option.viewType,
                      currentPoliticalAction.application.option.isMine,
                      'request',
                    ),
                  )
                "
                :status="currentPoliticalAction.application.option.viewType"
                :isMine="currentPoliticalAction.application.option.isMine"
              >
                <template v-slot:buttonText>
                  <lightning-icn
                    class="inline mb-1 ml-1"
                    :class="
                      currentPoliticalAction.application.option.isMine
                        ? 'blue-icon'
                        : 'white-icon'
                    "
                    width="20px"
                    height="20px"
                  ></lightning-icn>
                  <span
                    :class="['text-lg font-bold', selected ? 'text-blue' : '']"
                  >
                    行</span
                  >
                  <span
                    :class="['text-sm font-bold', selected ? 'text-blue' : '']"
                    >程
                  </span>
                </template>
              </app-document-status-button>
            </Tab>
            <Tab
              v-slot="{ selected }"
              v-bind:disabled="
                !canOpenTab(
                  currentPoliticalAction.report.option.viewType,
                  currentPoliticalAction.application.option.viewType,
                  currentPoliticalAction.report.option.isMine,
                  'report',
                )
              "
            >
              <app-document-status-button
                :class="[
                  'border-4 border-blue text-blue w-40 h-10 tab-button px-1',
                  selected ? 'tab-active bg-white' : 'border-dotted',
                ]"
                @click="
                  changeDocumentTitle(
                    'result',
                    canOpenTab(
                      currentPoliticalAction.report.option.viewType,
                      currentPoliticalAction.application.option.viewType,
                      currentPoliticalAction.report.option.isMine,
                      'report',
                    ),
                  )
                "
                :status="currentPoliticalAction.report.option.viewType"
                :isMine="currentPoliticalAction.report.option.isMine"
              >
                <template v-slot:buttonText>
                  <attach-icn
                    class="inline mb-1 ml-1.5"
                    :class="
                      currentPoliticalAction.report.option.isMine
                        ? 'blue-icon'
                        : 'white-icon'
                    "
                    width="20px"
                    height="20px"
                  ></attach-icn>
                  <span
                    class="ml-1"
                    :class="['text-lg font-bold', selected ? 'text-blue' : '']"
                    >概</span
                  >
                  <span
                    :class="['text-sm font-bold', selected ? 'text-blue' : '']"
                    >要</span
                  >
                </template>
              </app-document-status-button>
            </Tab>
            <Tab
              v-slot="{ selected }"
              v-bind:disabled="
                !canOpenTab(
                  currentPoliticalAction.memory.option.viewType,
                  currentPoliticalAction.application.option.viewType,
                  currentPoliticalAction.memory.option.isMine,
                  'memory',
                )
              "
            >
              <app-document-status-button
                :class="[
                  'border-4 border-blue text-blue w-40 h-10 tab-button px-1',
                  selected ? 'tab-active bg-white' : 'border-dotted',
                ]"
                :status="currentPoliticalAction.memory.option.viewType"
                :isMine="currentPoliticalAction.memory.option.isMine"
                @click="
                  changeDocumentTitle(
                    'memory',
                    canOpenTab(
                      currentPoliticalAction.memory.option.viewType,
                      currentPoliticalAction.application.option.viewType,
                      currentPoliticalAction.memory.option.isMine,
                      'memory',
                    ),
                  )
                "
              >
                <template v-slot:buttonText>
                  <receipt-icn
                    fill-rule="evenodd"
                    class="inline mb-1 ml-2"
                    :class="
                      currentPoliticalAction.memory.option.isMine
                        ? 'blue-icon'
                        : 'white-icon'
                    "
                    width="17px"
                    height="17px"
                  ></receipt-icn>
                  <span
                    class="ml-1"
                    :class="['text-lg font-bold', selected ? 'text-blue' : '']"
                    >費</span
                  >
                  <span
                    :class="['text-sm font-bold', selected ? 'text-blue' : '']"
                    >用</span
                  >
                </template>
              </app-document-status-button>
            </Tab>
          </TabList>

          <TabPanels class="mt-4">
            <TabPanel>
              <RequestOffice
                class="ml-2 mr-2 mb-5"
                v-if="
                  activityDialog.isOffice == false &&
                    currentUser.role.rank == 10 &&
                    currentUser.role.is_authorizer &&
                    currentPoliticalAction.application.option.viewType == 2
                "
                style="max-height: 450px; overflow-y: scroll;"
              />
              <RequestOffice
                class="ml-2 mr-2 mb-5"
                v-else-if="
                  activityDialog.isOffice == false &&
                    currentUser.role.rank == 2 &&
                    currentUser.role.is_authorizer &&
                    (currentPoliticalAction.application.option.viewType == 2 ||
                      currentPoliticalAction.application.option.viewType == 3)
                "
                style="max-height: 450px; overflow-y: scroll;"
              />

              <request-preview
                class="ml-2 mr-2 mb-5"
                v-else-if="
                  activityDialog.isPreview ||
                    (currentUser.role.rank !== 1 &&
                      currentPoliticalAction.application.option.viewType ==
                        1) ||
                    (currentUser.role.rank !== 1 &&
                      currentPoliticalAction.application.option.viewType ==
                        4) ||
                    (currentUser.role.rank !== 1 &&
                      currentPoliticalAction.application.option.viewType ==
                        5) ||
                    (currentUser.role.rank !== 1 &&
                      currentPoliticalAction.application.option.viewType ==
                        6) ||
                    (currentUser.role.rank !== 1 &&
                      currentPoliticalAction.application.option.viewType ==
                        7) ||
                    (currentUser.role.rank == 1 &&
                      currentPoliticalAction.application.option.viewType ==
                        4) ||
                    (currentUser.role.rank == 1 &&
                      currentPoliticalAction.application.option.viewType == 6)
                "
                style="max-height: 450px; overflow-y: scroll;"
              ></request-preview>

              <request-form-navigation color="blue" class="mr-8" v-else>
                <template v-slot:tabContent>
                  <RequestForm />
                </template>
              </request-form-navigation>
            </TabPanel>

            <TabPanel>
              <ResultOffice
                class="ml-2 mt-1 mb-5"
                v-if="
                  activityDialog.isOfficeResult == false &&
                    currentUser.role.rank == 10 &&
                    currentUser.role.is_authorizer &&
                    currentPoliticalAction.report.option.viewType == 2
                "
                style="max-height: 450px; overflow-y: scroll;"
              />
              <ResultOffice
                class="ml-2 mt-1 mb-5"
                v-else-if="
                  activityDialog.isOfficeResult == false &&
                    currentUser.role.rank == 2 &&
                    currentUser.role.is_authorizer &&
                    (currentPoliticalAction.report.option.viewType == 2 ||
                      currentPoliticalAction.report.option.viewType == 3)
                "
                style="max-height: 450px; overflow-y: scroll;"
              />
              <result-preview
                v-else-if="
                  activityDialog.isPreviewResult ||
                    (currentUser.role.rank !== 1 &&
                      currentPoliticalAction.report.option.viewType == 1) ||
                    (currentUser.role.rank !== 1 &&
                      currentPoliticalAction.report.option.viewType == 4) ||
                    (currentUser.role.rank !== 1 &&
                      currentPoliticalAction.report.option.viewType == 5) ||
                    (currentUser.role.rank !== 1 &&
                      currentPoliticalAction.report.option.viewType == 6) ||
                    (currentUser.role.rank !== 1 &&
                      currentPoliticalAction.report.option.viewType == 7) ||
                    (currentUser.role.rank == 1 &&
                      currentPoliticalAction.report.option.viewType == 4) ||
                    (currentUser.role.rank == 1 &&
                      currentPoliticalAction.report.option.viewType == 6)
                "
                class="ml-2 mr-2 mb-5"
                style="max-height: 450px; overflow-y: scroll;"
              ></result-preview>
              <result-form-navigation color="blue" class="mr-8" v-else>
                <template v-slot:tabContent>
                  <ResultForm />
                </template>
              </result-form-navigation>
            </TabPanel>

            <TabPanel>
              <MemoryOffice
                class="ml-2 mt-1 mb-5"
                v-if="
                  activityDialog.isOfficeMemory == false &&
                    currentUser.role.rank == 10 &&
                    currentUser.role.is_authorizer &&
                    currentPoliticalAction.memory.option.viewType == 2
                "
                style="max-height: 450px; overflow-y: scroll;"
              />
              <MemoryOffice
                class="ml-2 mt-1 mb-5"
                v-else-if="
                  activityDialog.isOfficeMemory == false &&
                    currentUser.role.rank == 2 &&
                    currentUser.role.is_authorizer &&
                    (currentPoliticalAction.memory.option.viewType == 2 ||
                      currentPoliticalAction.memory.option.viewType == 3)
                "
                style="max-height: 450px; overflow-y: scroll;"
              />
              <memory-preview
                v-else-if="
                  activityDialog.isPreviewMemory ||
                    (currentUser.role.rank !== 1 &&
                      currentPoliticalAction.memory.option.viewType == 1) ||
                    (currentUser.role.rank !== 1 &&
                      currentPoliticalAction.memory.option.viewType == 4) ||
                    (currentUser.role.rank !== 1 &&
                      currentPoliticalAction.memory.option.viewType == 5) ||
                    (currentUser.role.rank !== 1 &&
                      currentPoliticalAction.memory.option.viewType == 6) ||
                    (currentUser.role.rank !== 1 &&
                      currentPoliticalAction.memory.option.viewType == 7) ||
                    (currentUser.role.rank == 1 &&
                      currentPoliticalAction.memory.option.viewType == 4) ||
                    (currentUser.role.rank == 1 &&
                      currentPoliticalAction.memory.option.viewType == 6)
                "
                class="ml-2 mr-2 mb-2"
                style="max-height: 450px; overflow-y: scroll;"
              ></memory-preview>
              <memory-form-navigation color="blue" class="mr-8" v-else>
                <template v-slot:tabContent>
                  <MemoryForm />
                </template>
              </memory-form-navigation>
            </TabPanel>
          </TabPanels>
        </TabGroup>
      </div>
    </template>
    <template v-slot:dialogFooterActions>
      <user-circle-icn
        width="40px"
        height="40px"
        class="ml-1"
      ></user-circle-icn>

      <span
        class="scrollbar text-white ml-1 leading-tight"
        style="width:120px; overflow-x:scroll; white-space:nowrap;"
        v-if="currentPoliticalAction.user.uname"
      >
        {{ currentPoliticalAction.user.uname }}
        <br />{{
          dayjs(currentPoliticalAction.updatedAt).format('YYYY/M/D')
        }}更新
      </span>
      <div
        class="mr-1"
        :style="
          currentUser.role.is_authorizer
            ? 'position: absolute; left: 188px;'
            : 'margin-left:auto'
        "
      >
        <ActivitiesDialogRequestFooter
          v-if="activityDialog.currentDocumentType == 'request'"
          :approveStatus="currentPoliticalAction.application.option.viewType"
        />
        <ActivitiesDialogResultFooter
          v-else-if="activityDialog.currentDocumentType == 'result'"
          :approveStatus="currentPoliticalAction.report.option.viewType"
        />
        <ActivitiesDialogMemoriesFooter
          v-else-if="activityDialog.currentDocumentType == 'memory'"
          :approveStatus="currentPoliticalAction.memory.option.viewType"
        />
      </div>
    </template>
  </app-dialog>
</template>
<script>
import { onMounted } from 'vue'
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from '@headlessui/vue'
import { usePoliticalActionDialog } from '@/services/politicalActionToda/usePoliticalActionDialog'
import { usePoliticalActions } from '@/services/politicalActionToda/usePoliticalActions'
import { useRequestReject } from '@/services/politicalActionToda/useRequestReject'
import { useResultReject } from '@/services/politicalActionToda/useResultReject'
import { useMemoryReject } from '@/services/politicalActionToda/useMemoryReject'
import { useCurrentUser } from '@/services/useCurrentUser'

import AppDialog from '@/components/ui/AppDialog'
import AppDocumentStatusButton from '@/components/ui/uiToda/AppDocumentStatusButtonToda'

import RequestForm from '@/components/layout/requestToda/RequestForm'
import RequestPreview from '@/components/layout/requestToda/RequestPreview'
import RequestOffice from '@/components/layout/requestToda/RequestOffice'
import RequestFormNavigation from '@/components/layout/requestToda/RequestFormNavigation'

import ResultForm from '@/components/layout/resultToda/ResultForm'
import ResultPreview from '@/components/layout/resultToda/ResultPreview'
import ResultFormNavigation from '@/components/layout/resultToda/ResultFormNavigation'
import ResultOffice from '@/components/layout/resultToda/ResultOffice'

import MemoryForm from '@/components/layout/memoryToda/MemoryForm'
import MemoryPreview from '@/components/layout/memoryToda/MemoryPreview'
import MemoryFormNavigation from '@/components/layout/memoryToda/MemoryFormNavigation'
import MemoryOffice from '@/components/layout/memoryToda/MemoryOffice'

import ActivitiesDialogRequestFooter from '@/components/layout/activitiesToda/ActivitiesDialogRequestFooter'
import ActivitiesDialogResultFooter from '@/components/layout/activitiesToda/ActivitiesDialogResultFooter'
import ActivitiesDialogMemoriesFooter from '@/components/layout/activitiesToda/ActivitiesDialogMemoriesFooter'

import LightningIcn from '@/assets/icons/lightning-new.svg?inline'
import AttachIcn from '@/assets/icons/attach.svg?inline'
import ReceiptIcn from '@/assets/icons/receipt.svg?inline'
import UserCircleIcn from '@/assets/icons/user-circle.svg?inline'

export default {
  name: 'ActivitiesDialog_TODA',

  components: {
    AppDialog,
    AppDocumentStatusButton,
    RequestFormNavigation,
    RequestPreview,
    RequestForm,
    RequestOffice,
    ResultForm,
    ResultFormNavigation,
    ResultPreview,
    ResultOffice,
    MemoryForm,
    MemoryFormNavigation,
    MemoryPreview,
    MemoryOffice,
    LightningIcn,
    AttachIcn,
    ReceiptIcn,
    UserCircleIcn,
    TabGroup,
    TabList,
    Tab,
    TabPanels,
    TabPanel,
    ActivitiesDialogRequestFooter,
    ActivitiesDialogResultFooter,
    ActivitiesDialogMemoriesFooter,
  },

  setup() {
    const {
      activityDialog,
      dialogTitle,
      tabIndex,
      changeDocument,
      changeDocumentTitle,
      showPreview,
    } = usePoliticalActionDialog()

    const { currentUser } = useCurrentUser()
    const { resetRequestRejectedItems } = useRequestReject()
    const { resetResultRejectedItems } = useResultReject()
    const { resetMemoryRejectedItems } = useMemoryReject()

    onMounted(() => {
      resetRequestRejectedItems()
      resetResultRejectedItems()
      resetMemoryRejectedItems()
      activityDialog.isPreview = false
    })
    return {
      ...usePoliticalActions(),
      resetRequestRejectedItems,
      resetResultRejectedItems,
      resetMemoryRejectedItems,
      currentUser,
      activityDialog,
      dialogTitle,
      tabIndex,
      changeDocument,
      changeDocumentTitle,
      showPreview,
    }
  },
}
</script>
<style lang="scss" scoped>
.scrollbar::-webkit-scrollbar {
  display: none;
}
</style>
